// Методы для получения данных пользователя

import { apiRequest } from './index';

/**
 * Получение данных пользователя, его интеграций, потоков и пакетов
 * @param {number} reklId - ID пользователя
 * @returns {Promise} - Промис с данными пользователя
 */
/**
 * Создание нового потока с пакетами
 * @param {Object} integration - Выбранная интеграция
 * @param {Array} selectedFlows - Выбранные потоки
 * @param {Array} selectedPackages - Выбранные пакеты
 * @param {Object} userData - Данные пользователя
 * @returns {Promise} - Промис с результатом создания
 */
export const createFlowWithPackages = async (integration, selectedFlows, selectedPackages, userData) => {
  try {
    // Логика создания потока с пакетами
    console.log('Создание потока с пакетами:', { integration, selectedFlows, selectedPackages, userData });

    // Проходим по каждому выбранному пакету
    for (const pkg of selectedPackages) {
      // Проходим по каждому выбранному потоку
      for (const flow of selectedFlows) {
        const regions = pkg.selectedRegions?.map(region => region.id) || [];
        const data = {
          integration_id: integration.id,
          flow_guide_id: flow.id,
          paks_id: pkg.id,
          limit: pkg.limit,
          price: 1000,
          holiday_send: pkg.noWeekend || false,
          regions: regions
        };

        console.log('Данные для создания пакета:', data);
        const response = await apiRequest(`/pakets/${userData.id}/add`, 'POST', data);
        console.log('Ответ от сервера:', response);
      }
    }

    // Возвращаем успешный результат
    return { success: true };
  } catch (error) {
    console.error('Ошибка при создании потока с пакетами:', error);
    throw error;
  }
};

/**
 * Обновление пакета
 * @param {number} integrationId - ID интеграции
 * @param {number} paksId - ID пакета
 * @param {number} [price] - Цена пакета
 * @param {number} [limit] - Лимит лидов
 * @param {boolean} [noWeekend] - Отправка без выходных (по умолчанию false)
 * @param {Array<number>} [regions] - Список ID регионов
 * @returns {Promise} - Промис с результатом обновления
 */
export const updatePackage = async (integrationId, paksId, price, limit, noWeekend= false, regions = null) => {
  try {
    let data
    if (regions){
      data = {
      integration_id: integrationId,
      price: price !== undefined ? price : 0,
      limit: limit !== undefined ? limit : 0,
      regions: regions || [],
      holiday_send: noWeekend || false
    };
    } else {
      data = {
      integration_id: integrationId,
      price: price !== undefined ? price : 0,
      limit: limit !== undefined ? limit : 0,
      holiday_send: noWeekend || false
    };
    }


    console.log('Данные для обновления пакета:', data);
    const response = await apiRequest(`/pakets/${paksId}`, 'PATCH', data);
    console.log('Ответ от сервера при обновлении пакета:', response);
    
    return response;
  } catch (error) {
    console.error('Ошибка при обновлении пакета:', error);
    throw error;
  }
};

const getLeadsDataByPackageId = async (reklId, paksId) => {
  try {
    const leadsData = await apiRequest(`/leads/${reklId}/list?packet=${paksId}`, 'GET');
    return leadsData.data || [];
  } catch (error) {
    console.error('Ошибка при получении данных о лидах:', error);
    throw error;
  }
};

export const getUserData = async (reklId) => {
  try {
    // Получаем интеграции пользователя
    const integrationsData = await apiRequest(`integrations/${reklId}/list`, 'GET');

    // Получаем данные о пакетах и потоках пользователя
    const paketsResponse = await apiRequest(`pakets?rekl_id=${reklId}`, 'GET');
    const paketsData = paketsResponse.data?.pakets || [];
    console.log("paketsData: ", paketsData);

    // const leadsData = await apiRequest(`/leads/${reklId}/list`, 'GET')
    // const leadsList = leadsData.data.leads || [];
    // Получаем данные о всех потоках (flow-guides)
    const flowGuidesResponse = await apiRequest('flow-guides', 'GET');
    const flowGuidesData = flowGuidesResponse.data || [];

    // Создаем мапу для быстрого доступа к тексту потока по его ID
    const flowTextMap = {};
    flowGuidesData.forEach(flow => {
      flowTextMap[flow.id] = flow.text;
    });

    // Форматируем данные в плоский список потоков
    const flowsData = [];

    // Собираем все ID пакетов для одного запроса
    const packageIds = paketsData.map(item => item.id);
    // Получаем данные о лидах по всем пакетам за один раз
    const allLeadsData = await Promise.all(packageIds.map(pkgId => getLeadsDataByPackageId(reklId, pkgId)));

    // Создаем мапу для быстрого доступа к данным лидов по ID пакета
    const leadsByPackageMap = {};
    paketsData.forEach((item, index) => {
      leadsByPackageMap[item.id] = allLeadsData[index];
    });

    // Проходим по пакетам и формируем данные о потоках
    for (const item of paketsData) {
      const integrationId = item.integration_id;

      // Проверяем, существует ли уже элемент с таким flow_guide_id и integration_id
      const existingFlow = flowsData.find(
        flow => flow.flow_guide_id === item.flow_guide_id && flow.integration_id === integrationId
      );

      // Получаем текст потока из flowTextMap
      const flowText = flowTextMap[item.flow_guide_id] || '';

      if (existingFlow) {
        // Если элемент существует, добавляем пакет в его список пакетов
        const leadsData = leadsByPackageMap[item.id];
        existingFlow.pakets.push({
          id: item.id,
          name: item.paks_name,
          paks_id: item.paks_id,
          price: item.price,
          limit: item.limit,
          regions: item.regions,
          leads_current_month: leadsData.leads ? leadsData.leads.filter(lead => new Date(lead.created_at).getMonth() === new Date().getMonth()) : [],
          // leads: leadsList.filter(lead => lead.paket === item.id)
          leads: leadsData.total || 0
        });
      } else {
        // Если элемент не существует, создаем новый элемент
        const leadsData = leadsByPackageMap[item.id];
        flowsData.push({
          integration_id: integrationId,
          flow_guide_id: item.flow_guide_id,
          flow_guide_name: item.flow_guide_name,
          text: flowText,
          created_at: item.created_at ? new Date(new Date(item.created_at).setHours(0, 0, 0, 0)) : new Date(),
          pakets: [{
            id: item.id,
            name: item.paks_name,
            price: item.price,
            paks_id: item.paks_id,
            limit: item.limit,
            regions: item.regions,
            leads_current_month: leadsData.leads ? leadsData.leads.filter(lead => lead.paket === item.id && new Date(lead.created_at).getMonth() === new Date().getMonth()) : [],
            leads: leadsData.total || 0
          }]
        });
      }
    }
    
    return {
      integrations: integrationsData.data || [],
      flows: flowsData
    };
  } catch (error) {
    console.error('Ошибка при получении данных пользователя:', error);
    throw error;
  }
};